"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var funcParams_1 = require("./funcParams");
var fix_parent_1 = require("./fix$parent");
var schemaPath_1 = require("./schemaPath");
var cacheFuncs = {};
/**
 * tworzy funkcję agregującą na podstawie schematu
 * @param schema schemat
 * @param cache czy używać cache
 * @param debug czy dodać debugger, wtedy każde wywołanie funkcji się zatrzymuje
 */
function aggregateFunction(schema, cache, debug) {
    if (cache === void 0) { cache = true; }
    if (schema.aggregate) {
        var aggregateFunc = null;
        var cachekey = '';
        if (cache && !debug) {
            cachekey = "agg_" + schema.aggregate.func
                + ("||" + schema.aggregate.array)
                + ("||" + schema.aggregate.property)
                + ("||" + schema.aggregate.when);
            aggregateFunc = cacheFuncs[cachekey];
            if (aggregateFunc) {
                return aggregateFunc;
            }
        }
        // let aggregateFunc = cache ? schema.cache.aggregateFunc : null;
        // może być podanna jako tablica
        var arraylist = schema.aggregate.array;
        if (!Array.isArray(arraylist)) {
            arraylist = [arraylist];
        }
        var func = schema.aggregate.func || 'sum';
        var ifprop = schema.aggregate.when || schema.aggregate.if;
        if (ifprop) {
            ifprop = fix_parent_1.default(ifprop).replace(/\$item\./g, '$array[$index].');
        }
        var prop = schema.aggregate.property;
        if (prop) {
            var complexprop = /[\$\.]/.test(prop);
            if (!complexprop) {
                prop = '$array[$index].' + prop;
            }
            else {
                prop = fix_parent_1.default(prop).replace(/\$item\./g, '$array[$index].');
            }
        }
        else {
            prop = '$array[$index]';
        }
        var ftext = 'var $length = 0;\r\n';
        // ftext += `var sttime=(new Date()).getTime();var $length=0;`;
        switch (func) {
            case 'mul':
                ftext += "var $result = 1;\r\n";
                break;
            case 'min':
                if (schema.type === 'string') {
                    ftext += "var $result = '\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A\u017A';\r\n";
                }
                else {
                    ftext += "var $result = Infinity;\r\n";
                }
                break;
            case 'max':
                if (schema.type === 'string') {
                    ftext += "var $result = '';\r\n";
                }
                else {
                    ftext += 'var $result = -Infinity;\r\n';
                }
                break;
            case 'map':
                ftext += "var $result = [];\r\n";
                break;
            default:
                ftext += "var $result = 0;\r\n";
                break;
        }
        var ltext = '';
        // ltext += `// func: ${func}\r\n`;
        switch (func) {
            case 'avg':
            case 'sum':
                ltext += "$result += (" + prop + "); // func: " + func;
                break;
            case 'max':
                ltext += "var $v = (" + prop + "); // func: " + func + "\r\nif ($v > $result)\r\n  $result=$v";
                break;
            case 'min':
                ltext += "var $v = (" + prop + "); // func: " + func + "\r\nif ($v < $result)\r\n  $result=$v";
                break;
            case 'mul':
                ltext += "$result *= (" + prop + "); // func: " + func;
                break;
            case 'count':
                ltext += "$result++; // func: " + func;
                break;
            case 'first':
            case 'last':
                ltext += "$result = (" + prop + ");break; // func: " + func;
                break;
            case 'map':
                ltext += "$result.push(" + prop + "); // func: " + func;
                break;
        }
        if (ifprop) {
            if (func === 'first' || func === 'map') {
                // tslint:disable-next-line: max-line-length
                ltext = "var $arrayLength = $array.length;\r\nfor($index = 0; $index < $arrayLength; $index++) {\r\n  if (" + ifprop + ") { // if: " + (schema.aggregate.when || schema.aggregate.if) + "\r\n    $length++;\r\n    " + ltext + "\r\n  }\r\n}";
            }
            else {
                ltext = "var $index = $array.length;\r\n"
                    + ("while($index--) {\r\n  if (" + ifprop + ") { // if: " + (schema.aggregate.when || schema.aggregate.if) + "\r\n    $length++;\r\n    " + ltext + "\r\n  }\r\n}");
            }
            // ftext += `do {with(aaa[i]) {if (${ifprop}) {${ltext}}}} while(i--);`;
        }
        else {
            if (func === 'first' || func === 'map') {
                // tslint:disable-next-line: max-line-length
                ltext = "var $arrayLength = $array.length;\r\n$length += $arrayLength;\r\nfor($index = 0; $index < $arrayLength; $index++) {\r\n  " + ltext + "\r\n}";
            }
            else {
                ltext = "var $index = $array.length;\r\n$length += $index;\r\nwhile($index--) {\r\n  " + ltext + "\r\n}";
            }
        }
        for (var _i = 0, arraylist_1 = arraylist; _i < arraylist_1.length; _i++) {
            var arraykey = arraylist_1[_i];
            var subarray = null;
            var pp = arraykey.indexOf('/');
            if (pp > -1) {
                subarray = arraykey.substr(pp + 1);
                arraykey = arraykey.substr(0, pp);
            }
            var complexarray = /[\$\.]/.test(arraykey);
            if (!complexarray) {
                arraykey = 'this.' + arraykey;
            }
            arraykey = fix_parent_1.default(arraykey);
            if (subarray) {
                // tslint:disable-next-line: max-line-length
                ftext += "var $parentArray = " + arraykey + "; // array: " + schema.aggregate.array + "\r\nvar $parentLength = $parentArray.length;\r\nfor(var $parentIndex=0; $parentIndex<$parentLength; $parentIndex++) {\r\n  var $array=$parentArray[$parentIndex]." + subarray + ";\r\n  if ($array) {\r\n    " + ltext + "\r\n}\r\n}";
            }
            else {
                ftext += "var $array = " + arraykey + "; // array: " + schema.aggregate.array + "\r\n";
                /*
                switch (func) {
                  case 'min':
                  case 'max':
                  case 'mul': ftext+="if ($result===undefined && $array.length) "
                }
                */
                ftext += ltext;
                // ltext;
            }
        }
        if (func === 'avg') {
            ftext += '\r\nif ($length)\r\n  $result /= $length;';
        }
        switch (func) {
            case 'mul':
                ftext += "\r\nif ($length===0)\r\n  $result=0;";
                break;
            case 'min':
            case 'max':
                if (schema.type === 'string') {
                    ftext += "\r\nif ($length === 0)\r\n  $result = '';";
                }
                else {
                    ftext += "\r\nif ($length === 0)\r\n  $result = 0;";
                }
                break;
        }
        if (debug) {
            switch (schema.type) {
                case 'integer':
                    ftext += '\r\n$result = $methods.mround($result,0);';
                    break;
                case 'money':
                    ftext += '\r\n$result = $methods.mround($result,2);';
                    break;
                case 'number':
                    if (schema.precision) {
                        ftext += "\r\n$result = $methods.mround($result," + schema.precision + ");";
                    }
                    else {
                        // ftext += `\r\n$result = $result;`;
                    }
                    break;
                default:
                    // ftext += `\r\n$result = $result;`;
                    break;
            }
            ftext += "\r\nreturn $result;";
            // return (schema.cache.aggregateFunc = aggregateFunc = new Function(funcParams, ftext));
            ftext = "\r\n/*** debug only ***/\r\n\"" + schemaPath_1.default(schema, true) + "\"; // schema path\r\nconsole.debug($obj.$path); // model path\r\ndebugger;\r\n\r\n/*** function body ***/\r\n" + ftext;
            // ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        else {
            switch (schema.type) {
                case 'integer':
                    ftext += '\r\nreturn $methods.mround($result,0);';
                    break;
                case 'money':
                    ftext += '\r\nreturn $methods.mround($result,2);';
                    break;
                case 'number':
                    if (schema.precision) {
                        ftext += "\r\nreturn $methods.mround($result," + schema.precision + ");";
                    }
                    else {
                        ftext += "\r\nreturn $result;";
                    }
                    break;
                default:
                    ftext += "\r\nreturn $result;";
                    break;
            }
        }
        if (process.env.NODE_ENV !== 'production') {
            ftext = "\"use strict\";\r\n" + ftext;
        }
        aggregateFunc = new Function(funcParams_1.default, ftext);
        if (cache && !debug) {
            cacheFuncs[cachekey] = aggregateFunc;
        }
        return aggregateFunc;
        // return (schema.cache.aggregateFunc = aggregateFunc = new Function(funcParams, ftext));
    }
}
exports.default = aggregateFunction;
//# sourceMappingURL=aggregateFunction.js.map